import _ from 'lodash'

export const findActive = location => {
  const { pathname } = location
  return pathname && `/${_.last(pathname.split('/'))}`
}
